/** @returns {import('../agentQuestion/agentQuestionTypes.js').AgentQuestionPayload & { kind: string, freeTextOptionId: string | null }} */
export function buildDesignDnaFigmaPublishAgentQuestion() {
  return {
    id: 'agent-question-design-dna-figma-publish',
    kind: 'designDnaFigmaPublish',
    status: 'open',
    freeTextOptionId: null,
    prompt:
      'The showcase is ready. I see **4 Figma projects** in your workspace — **which project should I publish the design system to?** Pick one and I\'ll create the library file there.',
    options: [
      { id: 'a', letter: 'A', label: 'NexusB2B Design System' },
      { id: 'b', letter: 'B', label: 'WebApp UI Library' },
      { id: 'c', letter: 'C', label: 'Enterprise Dashboard Kit' },
      { id: 'd', letter: 'D', label: 'Acme Marketing Site' },
    ],
    allowFreeText: false,
    agentBrand: 'SIA',
    agentName: 'Master Root Agent',
  }
}
